import React from 'react';
import { Box, Button, useWindowSize } from 'vindi-ds-components';

function ButtonSubmit() {
  const { isMobile } = useWindowSize();

  return (
    <Box mt={4} mb={5}>
      <Button
        type='submit'
        size='large'
        style={{
          width: isMobile ? '100%' : 'auto',
          maxWidth: isMobile ? '100%' : 'auto',
        }}
      >
        <Box component='span' px={5}>
          Criar cliente
        </Box>
      </Button>
    </Box>
  );
}

export default ButtonSubmit;
